import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';

@Component({
  name: 'bpc-free-text',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class FreeText extends mixins(AbstractField) {
  get configText() {
    const configText = this.$attrs.text;
    return this.$t(configText);
  }
}
